import { PostgrestError } from '@supabase/supabase-js';
import { NestedUser } from '@habity/types';
import { createClient } from '~/lib/providers/supabase/client';
import { useUser } from './useUser';
import { nextGetAPI } from '~/lib/api';
import { useRouter } from 'next/navigation';

export const useUsers = () => {
  const supabaseClient = createClient();
  // const setUser = useUserStore((state) => state.setUser);
  const { user } = useUser();
  const { push, refresh } = useRouter();

  const updateUser = async (userData: Partial<NestedUser | null>) => {
    // setLoading(true);
    // if (!user || !supabaseClient) return;
    // setUser({ ...user, ...userData });

    // SUPABASE: Convert to server action
    const { error }: { error: PostgrestError | null } = await supabaseClient
      .from('users')
      .update({ ...userData, updated_at: new Date() })
      .eq('id', user?.id);
    if (error) console.error(error);

    // TODO: Replace server refresh with client mutation
    refresh();

    // setLoading(false);
    return {
      error,
    };
  };

  const acceptTerms = async () => {
    if (!user || !supabaseClient) return;
    await updateUser({ terms_accepted_at: new Date().toISOString() });
  };

  const signOut = async () => {
    // Get current path to redirect back after logout
    const currentPath = typeof window !== 'undefined' ? window.location.pathname + window.location.search : '/';
    
    // SUPABASE: Auth call
    if (supabaseClient) supabaseClient.auth.signOut();
    
    await nextGetAPI(`/auth/signout`);
    
    // Redirect back to the same page
    push(currentPath);
    refresh();
  };

  return { updateUser, acceptTerms, signOut };
};
